import { ReactComponent as StopWatch } from "../assets/Stopwatch.svg";
export const TimerComp = ({ time, justTimer = false }: any) => {
  return (
    <span className="timer_comp">
      <StopWatch />
      <span> {time || "--:--:--"} </span>
    </span>
  );
};
